import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import Modal from "../../../../portals/Modal";
import branchActions from "../../../../store/branchStore/branchActions";
import PageHeader from "../../../../components/PageHeader";
import CustomSelect from "../../../../components/FormElements/Select";
import TextField from "../../../../components/FormElements/TextField";
import styles from './profileBonusTerm.module.scss';
import YOUTUBE_LINKS from "../../../../config/youtubeLinks";
import VideoModal from "../../../../components/VideoModal";
import { EXPIRATION_OPTIONS } from "../../../../config/expirationOptions";

export default function ProfileBonusTerm() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const info = useSelector((s) => s.branchReducer.info);
    const [state, setState] = useState(null);
    const [errorModal, setErrorModal] = useState(false);
    const [error, setError] = useState(false);
    const [pending, setPending] = useState(false);
    const [expireInterval, setExpireInterval] = useState({label: t('NSAwards.limit'), value: 0});
    const [bonusPercentage, setBonusPercentage] = useState({label: '', value: ''});
    const [expirePercentage, setExpirePercentage] = useState({label: '', value: ''});
    const [bonusName, setBonusName] = useState('');

    const options = EXPIRATION_OPTIONS;
    const expireOptionsPercentage = [
        {
            "label": <span>30%</span>,
            "value": 30,
        },
        {
            "label": <span>50%</span>,
            "value": 50,
        },
        {
            "label": <span>100%</span>,
            "value": 100,
        },
    ]
    const optionsPercentage = [
        {
            "label": <span>50%</span>,
            "value": 50,
        },
        {
            "label": <span>100%</span>,
            "value": 100,
        },
    ]

    useEffect(() => {
        setState(null);
        setError(false);

        if (info && !info.configuration.private_cashback) {
            setError(true);
            return setErrorModal(true);
        }

        if (info && info.configuration.private_cashback) {
            let currentPercentage = expireOptionsPercentage.find(o => o.value === info.configuration.private_cashback.access_withdraw_bonus_percentage);

            if (currentPercentage) {
                setExpirePercentage(currentPercentage);
            }

            setState({
                access_withdraw_bonus_percentage: info.configuration.private_cashback.access_withdraw_bonus_percentage,
            });
        }

        if (info && info.configuration.private_cashback) {
            let currentOption = options.find(o => o.value === info.configuration.private_cashback.expire_interval);
            let currentPercentage = optionsPercentage.find(o => o.value === info.configuration.private_cashback.bonus_percentage);

            if (currentOption) {
                setExpireInterval(currentOption);
            }
            if (currentPercentage) {
                setBonusPercentage(currentPercentage);
            }
            if (info.configuration.private_cashback.bonus_name) {
                setBonusName(info.configuration.private_cashback.bonus_name);
            }

            setState({
                expire_interval: info.configuration.private_cashback.expire_interval,
            });
        }
    }, [info])

    useEffect(() => {
        setState({
            expire_interval: expireInterval.value
        });
    }, [expireInterval])

    const onSubmit = () => {
        if (state && info && bonusPercentage.value) {
            setPending(true);
            new Promise((resolve, reject) => {
                const { banner, expire_date, ...otherParams } = info.configuration.private_cashback;
                dispatch(branchActions.changePrivateCashbackExpireDate(info.id, {
                    ...otherParams,
                    access_withdraw_bonus_percentage: expirePercentage?.value ? expirePercentage.value : 0,
                    expire_interval: state.expire_interval,
                    bonus_percentage: bonusPercentage.value,
                    bonus_name: bonusName,
                }, resolve, reject));
            }).finally(() => {
                setPending(false);
            })
        }
    }

    return (
        <>
          <PageHeader title={t('bonuses')}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'center' }}>
                <p>{t('NSBonus.information')}</p>
                <VideoModal url={YOUTUBE_LINKS.BonusExpire} />
              </div>
            </PageHeader>
            {info?.configuration?.private_cashback?.is_cascade && (
                <div style={{
                    display: 'flex', alignItems: 'flex-start', gap: 10,
                    padding: '12px 16px',
                    backgroundColor: 'rgba(78, 183, 139, 0.08)',
                    border: '1px solid rgba(78, 183, 139, 0.3)',
                    borderRadius: 8, marginBottom: 16, maxWidth: 600,
                    fontFamily: 'sf, serif', fontSize: 13, lineHeight: 1.5, color: '#576478',
                }}>
                    <span style={{ flexShrink: 0, fontSize: 16 }}>&#9432;</span>
                    <span>{t('NSBonusMode.cascadeBannerBonusTerm')}</span>
                </div>
            )}
            <div className={styles.container}>
                <div className={styles.block}>
                    <div className={styles['block__title']}>{t('combustion')} <span>*</span></div>
                    <CustomSelect
                      options={optionsPercentage}
                      value={bonusPercentage}
                      onSelect={(o) => setBonusPercentage(o)}
                    />
                </div>
                <div className={styles.block}>
                    <div className={styles['block__title']}>{t('period')} <span>*</span></div>
                    <CustomSelect
                        options={options}
                        value={expireInterval}
                        onSelect={(o) => setExpireInterval(o)}
                    />
                </div>
                <div className={styles.block}>
                    <div className={styles['block__title']}>{t('NSBonus.bonusName')}</div>
                    <TextField
                        value={bonusName}
                        onChange={(e) => setBonusName(e.target.value)}
                        placeholder={t('NSBonus.bonusNamePlaceholder')}
                    />
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ marginRight: '18px' }}>
                        <ButtonFilled disabled={!state || error} loading={pending} onClick={onSubmit}>
                            {t('save')}
                        </ButtonFilled>
                    </div>
                </div>
            </div>
            <Modal
                open={errorModal} size="small"
                onClickClose={() => setErrorModal(false)}>
                <div className={styles.modal}>
                    <p>
                        {t('optionForbidden')} <br/>
                        {t('touchModerator')}
                    </p>
                    <div>
                        <ButtonFilled
                            onClick={() => setErrorModal(false)}
                        >{t('close')}</ButtonFilled>
                    </div>
                </div>
            </Modal>
        </>
    )
}
